import { Button, message, Upload } from "antd";
import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { UploadFile } from "antd/es/upload/interface";

interface ImageItem {
  uid: string;
  name: string;
  status: UploadFile["status"];
  url: string;
}
type Props = {
  image_name: string;
  field: string;
  setFieldValue: (field: string, value: any) => void;
  logoFileList: ImageItem[];
  setLogoFileList: React.Dispatch<React.SetStateAction<ImageItem[]>>;
};

const SelectImage: React.FC<Props> = ({
  image_name,
  field,
  setFieldValue,
  logoFileList,
  setLogoFileList,
}) => {
  const getBase64 = (file: File, callback: (base64: string) => void) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result as string);
    reader.onerror = (error) => {
      message.error("Faylı yükləmək alınmadı.");
    };
  };
  return (
    <div className="input_wrapper">
      <Upload
        name={field}
        fileList={logoFileList}
        beforeUpload={(file) => {
          getBase64(file, (base64: string) => {
            setFieldValue(field, base64);
            setLogoFileList([
              {
                uid: file.uid,
                name: file.name,
                status: "done",
                url: base64,
              },
            ]);
          });
          return false;
        }}
        onRemove={() => {
          setFieldValue(field, "");
          setLogoFileList([]);
        }}
        showUploadList={false}
        maxCount={1}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {logoFileList.length > 0 && (
            <>
              <img
                src={logoFileList[0].url || ""}
                alt="page_image"
                style={{
                  width: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginTop: "10px",
                }}
              />
              <p
                style={{
                  margin: "8px 0 0",
                  fontSize: "14px",
                  color: "#555",
                }}
              >
                {logoFileList[0].name}
              </p>
            </>
          )}
          <Button icon={<UploadOutlined />}>{image_name}</Button>
        </div>
      </Upload>
    </div>
  );
};

export default SelectImage;
